import axiosInstance from "../../../../axiosInstance";
import { error, info, success } from "../../../../store/notification/actions";

export const addStore = (data) => {
  info("Saving Pharmacy...");
  return axiosInstance
    .post("/store/addStore", {
      user_id: data.userId,
      email: data.email,
      store_name: data.storeName,
      store_alias: data.storeAlias,
      street1: data.street1,
      street2: data.street2,
      country: data.country.optionname,
      state: data.state.optionname,
      city: data.city.optionname,
      zipcode: data.zip,
      plan: data.plan,
      store_landline: data.storeLandline,
      store_tax_number: data.storeTaxNumber,
    })
    .then((res) => {
      if (res.data.status === "success") {
        success("Pharmacy added Successfully...");
        return { message: "", hasError: false, data: res.data.data };
      } else {
        const errorMessage = res.data?.error[0]?.message;
        error(errorMessage);
        return {
          message: errorMessage,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response?.data?.error[0]?.message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};

export const getPlans = () => {
  return axiosInstance
    .get("/store/getPlans")
    .then((res) => {
      return { message: "", hasError: false, data: res.data.data[0] };
    })
    .catch((err) => {
      const errorMessage = err.response?.data?.error[0]?.message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};
